/*
 * InteractiveList Messages
 *
 * This contains all the text for the InteractiveList .
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.UIKit.InteractiveList';

export default defineMessages({
  placeholderTitle: {
    id: `${scope}.placeholder.title`,
    defaultMessage: 'Aggiungi optional',
  },
  placeholderDescription: {
    id: `${scope}.placeholder.description`,
    defaultMessage: 'Per aggiungere optional vai nella scheda Equipaggiamenti, Optional.',
  },
  remove: {
    id: `${scope}.remove`,
    defaultMessage: 'Rimuovi tutti',
  },
  show: {
    id: `${scope}.show`,
    defaultMessage: 'Mostra tutti',
  },
  hide: {
    id: `${scope}.hide`,
    defaultMessage: 'Nascondi',
  },
  removeItem: {
    id: `${scope}.removeItem`,
    defaultMessage: 'Clicca per rimuovere',
  },
});
